import { render, staticRenderFns } from "./TemplateListagemVazia.vue?vue&type=template&id=fa8d55ac"
import script from "./TemplateListagemVazia.vue?vue&type=script&lang=js"
export * from "./TemplateListagemVazia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports